export const STOP_LOSS_FORM_CHANGE = 'STOP_LOSS_FORM_CHANGE'
